import {Box, Grid, Radio, Typography} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'

import {useAction} from '../../../actions'
import type {ActionConfig} from '../../../actions/types'
import {tagToUrl} from '../../../lib/tagToUrl'
import {renderWidget} from '../../../widgets'
import type {Image, TextWidgetConfig} from '../../types'
import * as classes from './VerticalItem.classes'

export type VerticalItemProps = {
  value: string
  title?: {items: TextWidgetConfig[]} | undefined
  subtitle?: {items: TextWidgetConfig[]} | undefined
  icon: Image
  active?: boolean
  tag?: 'New!'
  onClick: (id: string) => void
  action_instead_of_default?: ActionConfig
  badge?: 'Бизнес'
}

export function VerticalItem(props: VerticalItemProps): ReactElement {
  const {value, title, subtitle, icon, active, tag, onClick, action_instead_of_default, badge} = props
  const {ActionComponent, triggerAction} = useAction(action_instead_of_default)

  return (
    <>
      <Grid
        className={classes.verticalItem}
        data-e2e={`tariff-${value}`}
        onClick={() => {
          if (action_instead_of_default) {
            triggerAction?.()
          } else {
            onClick(value)
          }
        }}
        container
      >
        {badge && (
          <div className={classes.businessBadge}>
            <Typography color="invert" thickness="medium" variant="caption2">
              {badge}
            </Typography>
          </div>
        )}
        <Box alignItems="flex-start" className={classes.wrapper.top} justifyContent="space-between">
          <img alt="" className={classes.image} src={tagToUrl(icon.image_tag)} />
          <Radio checked={active} className={classes.radio} />
        </Box>
        <Box className={classes.wrapper.content} flexDirection="column">
          <Box my="xs">
            <div className={classes.title}>{title && title.items.map(renderWidget)}</div>
            {tag && tag === 'New!' ? (
              <div className={classes.badgeContainer}>
                <div className={classes.badgeNew}>
                  <Typography color="invert" thickness="medium" variant="caption2">
                    {tag}
                  </Typography>
                </div>
              </div>
            ) : null}
          </Box>

          {subtitle &&
            subtitle.items.map((item, index) => (
              <Typography key={index} color="minor" variant="caption2">
                {item.text}
              </Typography>
            ))}
        </Box>
        {ActionComponent}
      </Grid>
    </>
  )
}
